import script from "./GGanttCurrentTime.vue?vue&type=script&setup=true&lang=ts"
export * from "./GGanttCurrentTime.vue?vue&type=script&setup=true&lang=ts"

import "./GGanttCurrentTime.vue?vue&type=style&index=0&id=dbd35106&lang=css"

const __exports__ = script;

export default __exports__